export default __webpack_public_path__ + "static/media/returnMoneyPrimaryColor.fbf0e1a1.svg";